import { render, staticRenderFns } from "./ShopGroupItem.vue?vue&type=template&id=55e01bba&scoped=true&"
import script from "./ShopGroupItem.vue?vue&type=script&lang=ts&"
export * from "./ShopGroupItem.vue?vue&type=script&lang=ts&"
import style0 from "./ShopGroupItem.vue?vue&type=style&index=0&id=55e01bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e01bba",
  null
  
)

export default component.exports